import { TableCell, TableHead, Text } from 'platform-components';
import React from 'react';

import './lessons__head.scss';

interface Props {
    shouldShowLikes: boolean;
}

const LessonHead = (props: Props) => {
    const { shouldShowLikes } = props;

    return (
        <TableHead mix="lessons__table-head">
            <TableCell mix="lessons__table-column-name lessons__lesson-name">
                <Text id="lessons.tableHeader.name" />
            </TableCell>
            {shouldShowLikes && (
                <TableCell mix="lessons__table-column-likes">
                    <Text id="lessons.tableHeader.likes" />
                </TableCell>
            )}
            <TableCell mix="lessons__table-column-status">
                <Text id="lessons.tableHeader.status" />
            </TableCell>
            <TableCell mix="lessons__table-column-date-assignment">
                <Text id="lessons.tableHeader.dateAssignment" />
            </TableCell>
            <TableCell mix="lessons__lesson-settings" />
        </TableHead>
    );
};

export default LessonHead;
